module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"modalTitle":"Download the Keap app","title":"Easily scan business cards using the Keap mobile app.","desktopTitle":"Save time. Scan your business cards with the Keap mobile app."}}')
  delete Component.options._Ctor
}
